/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Opportunitiescolumnplace2Inputs */

const en_opportunitiescolumnplace2 = /** @type {(inputs: Opportunitiescolumnplace2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Area`)
};

const de_opportunitiescolumnplace2 = /** @type {(inputs: Opportunitiescolumnplace2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gebiet`)
};

/**
* | output |
* | --- |
* | "Area" |
*
* @param {Opportunitiescolumnplace2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const opportunitiescolumnplace2 = /** @type {((inputs?: Opportunitiescolumnplace2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Opportunitiescolumnplace2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_opportunitiescolumnplace2(inputs)
	return de_opportunitiescolumnplace2(inputs)
});
export { opportunitiescolumnplace2 as "opportunitiesColumnPlace" }